import { render, staticRenderFns } from "./BarChartVideoNumber.vue?vue&type=template&id=204038c0&scoped=true&"
import script from "./BarChartVideoNumber.vue?vue&type=script&lang=js&"
export * from "./BarChartVideoNumber.vue?vue&type=script&lang=js&"
import style0 from "./BarChartVideoNumber.vue?vue&type=style&index=0&id=204038c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204038c0",
  null
  
)

export default component.exports